import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function NoMatch(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: '48px 24px',
      }}
    >
      <Typography variant="h4" gutterBottom>
        {t('noMatch')}
      </Typography>
      <Typography variant="h6">
        <Link to="/">{t('goToTheHomePage')}</Link>
      </Typography>
    </Box>
  );
}
